import { addEventListener } from "js-utils/src/event";

import init from "../../common/base/init";

// Toggling on mobile
// Can be toggled on by any button that has `.js--sidebar-trigger` class

init(() => {
  const openFormBtn = document.querySelector(".button--open-form");
  const saveSearchForm = document.querySelector(".-save-form");

  if (openFormBtn) {
    addEventListener(openFormBtn, "click", function(e) {
      saveSearchForm.classList.add("--visible");
      openFormBtn.classList.remove("--visible");
    });
  }
});
